import React, { useContext, useEffect, useState } from 'react';
import cl from './TransportPrice.module.css'  
import { AppContext } from '../../../../../providers/appProvider'; 
import { useUpdateEffect } from '../../../../../hooks/useUpdateEffect';


const TransportPrice = ({ containerService, defaultContainer, onCloseTransportPrice, typeOfPrice }) => {
 
    
    const containerResetData = {
        id: defaultContainer.id,

        frast_price: defaultContainer.frast_price,
        land_price: defaultContainer.land_price,
        other_price: defaultContainer.other_price,
        thc_price: defaultContainer.thc_price,
        land_other_price: defaultContainer.land_other_price,
  
        client_frast_price: defaultContainer.client_frast_price,
        client_land_price: defaultContainer.client_land_price,
        client_other_price: defaultContainer.client_other_price,
        client_thc_price: defaultContainer.client_thc_price, 
        client_land_other_price: defaultContainer.client_land_other_price,
 
    }

 
 

    const [newContainer, setNewContainer] = useState(containerResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const { appState, app } = useContext(AppContext);
  
    const validateContainer = (container) => {
        const messages = {}; 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
         return isValid;
    };
 
    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateContainer(newContainer)
        }
    }, [newContainer, isFirstValidated]);

 
    
    const getTransportPrice = (sender_city_id, receiver_city_id, marine_line_id, agent_id, send_at) => {
        console.log(appState.container_prices);
    
        return new Promise((resolve, reject) => {
            // Convert send_at to a Date object
            const sendDate = new Date(send_at);
            console.log('არჩეული თარიღი '+ sendDate);

            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);
                    console.log(periodStartAt);
                    console.log(periodEndAt);

                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.marine_line.id === marine_line_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult); 
            }
        });
    };

    const getTransportPriceExtra = (sender_city_id, receiver_city_id, land_type_id, agent_id, send_at) => {
        console.log(appState.container_prices);
    
        return new Promise((resolve, reject) => {
            const sendDate = new Date(send_at);
            console.log('არჩეული თარიღი: ' + sendDate);
    
            var initialResult = appState.container_prices.find(
                (obj) => {

                    const periodStartAt = new Date(obj.period_start_at);
                    const periodEndAt = new Date(obj.period_end_at);
    
                    return (
                        obj.sender_city.id === sender_city_id &&
                        obj.reciever_city.id === receiver_city_id &&
                        obj.type_id === land_type_id &&
                        obj.agent.id === agent_id &&
                        (periodStartAt <= sendDate && periodEndAt >= sendDate)
                    );
                }
            );
    
            if (!initialResult) {
                return reject(new Error('Not found initial Price entry by transport_price_id'));
            } else {
                resolve(initialResult);
            }
        });
    };



    useUpdateEffect(() => {
        if (newContainer.sender_city_id > 0 || newContainer.send_at.length > 1) { 
            var reciever = newContainer.reciever_city_id
 
            const priceResponse = getTransportPrice(newContainer.sender_city_id, reciever, newContainer.marine_line_id, newContainer.agent_id, newContainer.send_at);
            priceResponse.then(result => {
                setNewContainer(prevState => ({
                    ...prevState,
                    thc_price: result.thc_price,
                    frast_price: result.frast_price, 
                    other_price: result.other_price, 

                    client_thc_price: result.client_thc_price,
                    client_frast_price: result.client_frast_price, 
                    client_other_price: result.client_other_price, 
                }));
            })
            .catch(err => {
                console.log(err)
                setNewContainer(prevState => ({
                    ...prevState,
                    thc_price: 0,
                    frast_price: 0, 
                    other_price: 0, 

                    client_thc_price: 0,
                    client_frast_price: 0, 
                    client_other_price: 0, 
                })); 
            });

            if (newContainer.final_destination_city_id > 0 || newContainer.send_at.length > 1) {
                reciever = newContainer.final_destination_city_id

                const priceResponse = getTransportPriceExtra(newContainer.reciever_city_id, reciever, newContainer.land_type_id, newContainer.agent_id, newContainer.send_at);
                priceResponse.then(result => {
                    setNewContainer(prevState => ({
                        ...prevState,
                        land_price: result.land_price, 
                        land_other_price: result.other_price, 
    
                        client_land_price: result.client_land_price, 
                        client_land_other_price: result.client_other_price, 
                    }));
                })
                .catch(err => {
                    console.log(err)
                        setNewContainer(prevState => ({
                        ...prevState,
                        land_price: 0, 
                        land_other_price: 0, 
    
                        client_land_price: 0, 
                        client_land_other_price: 0,
                    })); 
                }); 
            }
        } else {
            /*setNewContainer(prevState => ({
                ...prevState,
                land_price: 0,
                thc_price: 0,
                frast_price: 0, 
                other_price: 0, 

                client_land_price: 0,
                client_thc_price: 0,
                client_frast_price: 0, 
                client_other_price: 0, 
            })); */
        }
    }, [newContainer.reciever_city_id, newContainer.sender_city_id, newContainer.marine_line_id, newContainer.land_type_id, newContainer.final_destination_city_id,newContainer.send_at]);


    const saveHandle = () => {

        const isValidate = validateContainer(newContainer)
        var newVar = {
            ...newContainer 
        }
        if (isValidate === true) {

            if (typeOfPrice === 'clientPrice') { 

                containerService.updateClientPrice(newVar) 

            }
            if (typeOfPrice === 'companyPrice') { 

                containerService.updateCompanyPrice(newVar) 

            }

            onCloseTransportPrice()

        } else {
           // setIsFirstValidated(true)
        }

    };

    const handleContainerChange = async (event) => {
        let val = event.target.value;
        setNewContainer(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const handleContainerChangeInt = async (event) => {
        let val = parseInt(event.target.value, 10); 
        setNewContainer(prevClient => ({
          ...prevClient,
          [event.target.name]: val
        }));
      };

    
    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; 
    
        if (!regex.test(keyValue)) {
          event.preventDefault();
        }
    };

    const handleFocus = (e) => { 
        
        if (e.target.value === '0') {
            setNewContainer({
                ...newContainer,
                [e.target.name]:  ''
              });
        }
    };


    const handleBlur = (e) => { 
        if (e.target.value === '') {
          let val = convertToInt(0);
            setNewContainer({
              ...newContainer,
              [e.target.name]:  val
            });
        };  
       };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    return (
        <>
  

            {typeOfPrice === "clientPrice" ? (

                <div>
                
                    <div  className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                            <input type="textS"
                                className={validates && validates.client_frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="client_frast_price" name="client_frast_price" value={newContainer.client_frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                            <label htmlFor="client_frast_price">ფრახტი</label>
                    </div>

                    <div  className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                        <input type="textS"
                            className={validates && validates.client_thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                            onFocus={handleFocus} 
                            onBlur={handleBlur} 
                            onKeyPress={handleKeyPress}
                            id="client_thc_price" 
                            name="client_thc_price" 
                            value={newContainer.client_thc_price} 
                            onChange={handleContainerChangeInt} 
                            autoComplete="off" />
                        <label htmlFor="client_thc_price">THC ფასი</label>
                    </div>

                    <div  className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                        <input type="textS"
                                className={validates && validates.client_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="client_other_price" name="client_other_price" value={newContainer.client_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                        <label htmlFor="client_other_price">სხვა</label>
                    </div> 
 
                    {newContainer.land_type_id === 0 ? (
                        <></> 

                    ) : (

                        <> 
                            
                            <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                    <input type="textS"
                                        className={validates && validates.client_land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                        id="client_land_price" name="client_land_price" value={newContainer.client_land_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                    <label htmlFor="client_land_price">სახმელეთო</label>
                            </div>

                            <div className={cl.groupPrice + ' ' + cl.blue + ' ' + cl.dollar}>
                                <input type="textS"
                                        className={validates && validates.client_land_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                        id="client_land_other_price" name="client_land_other_price" value={newContainer.client_land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                <label htmlFor="client_land_other_price">სახმელ. სხვა</label>

                            </div>

                        </>

                    )}


                </div>



 
            ) : typeOfPrice === "companyPrice" ? (
 
 

                <div>
                            
                    <div  className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <input type="textS"
                                className={validates && validates.frast_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="frast_price" name="frast_price" value={newContainer.frast_price} onChange={handleContainerChangeInt} autoComplete="off" />
                        <label htmlFor="frast_price">ფრახტი</label> 
                        
                    </div>

                    <div  className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                        <input type="textS"
                                className={validates && validates.thc_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="thc_price" name="thc_price" value={newContainer.thc_price} onChange={handleContainerChangeInt} autoComplete="off" />
                        <label htmlFor="thc_price">THC ფასი</label> 
                    </div>

                    <div  className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                            <input type="textS"
                                className={validates && validates.other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                id="other_price" name="other_price" value={newContainer.other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                            <label htmlFor="other_price">სხვა</label>
                    </div>

                    {newContainer.land_type_id === 0 ? (
                        <></> 

                    ) : ( 
                        <>
                            <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                    <input type="textS"
                                        className={validates && validates.land_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                        id="land_price" name="land_price" value={newContainer.land_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                    <label htmlFor="land_price"> სახმელეთო</label>
                            </div>

                            <div className={cl.groupPrice + ' ' + cl.yellow + ' ' + cl.dollar}>
                                    <input type="textS"
                                        className={validates && validates.land_other_price ? cl.input + ' ' + cl.errorInput : cl.input}
                                        onFocus={handleFocus} onBlur={handleBlur} onKeyPress={handleKeyPress}
                                        id="land_other_price" name="land_other_price" value={newContainer.land_other_price} onChange={handleContainerChangeInt} autoComplete="off" />
                                    <label htmlFor="land_other_price">სახმელ. სხვა</label> 
                            </div> 
                        </>

                    )}


                </div>
            ) : null}

      

            <div style={{ display: 'flex', marginTop: 5, gap: '5px' }}>
                <span onClick={saveHandle} className={cl.YesBtn}>შენახვა</span>
                <span onClick={onCloseTransportPrice} className={cl.NoBtn} >გაუქმება</span>
            </div>
  
        </>
    );

};

export default TransportPrice;